import Ecommerce from '../components/dashboard/ecommerce';
import Donation from '../components/Donation/donation';
import BankMaster from '../components/BankMaster/bankMaster';
import DonationMaster from '../components/DonationMaster/DonationMaster';
import Donar from '../components/DonarMaster/donar';
import Income from '../components/Income/income';
import Organization from '../components/Organization/Organizationa';
import PrivillageManager from '../components/PrivillageManager/PrivillageManager';
import ModualManager from '../components/ModualManager/ModualManager';
import Notes from '../components/Notes/notes';
import Statement from '../components/Statement/Statement';
import Expace from '../components/Expance/expance';
import SlipDownloadeTemplate from '../components/SlipDownloadeTemplate/SlipDownloadeTemplate';
import DonationAdd from '../components/Donation/DonationAdd';
import Temple from '../components/Temple/temple';
import TempleTrust from '../components/Temple_Trust/templeTrust';
import ExpanseAdd from '../components/Donation/ExpanseAdd';
import Accommodation from '../components/Accommodation/Accommodation';
import AccommodationDetail from '../components/Accommodation/AccommodationDetail';
import BillManagement from '../components/BillManagement/BillManagement';
import PaymentBillManagement from '../components/PaymentBillManagement/PaymentBillManagement';
import Users from '../components/Users/users';
import Events from '../components/Events/Events';
import EventDetail from '../components/Events/EventDetail';
import MealPass from '../components/MealPass/MealPass';


export const routes = [
  {
    path: `${process.env.PUBLIC_URL}/Users/users/:layout/`,
    Component: <Users />
  },
  {
    path: `${process.env.PUBLIC_URL}/dashboard/ecommerce/:layout/`,
    Component: <Ecommerce />
  },
  {
    path: `${process.env.PUBLIC_URL}/Donation/:type/:layout/`,
    Component: <Donation />
  },
  {
    path: `${process.env.PUBLIC_URL}/Expanse/:type/:layout/`,
    Component: <Donation />
  },
  {
    path: `${process.env.PUBLIC_URL}/Donation/DonationAdd/:layout/`,
    Component: <DonationAdd />
  },
  {
    path: `${process.env.PUBLIC_URL}/Donation/ExpanseAdd/:layout/`,
    Component: <ExpanseAdd />
  },
  {
    path: `${process.env.PUBLIC_URL}/BankMaster/bankMaster/:layout/`,
    Component: <BankMaster />
  },
  {
    path: `${process.env.PUBLIC_URL}/Temple/temple/:layout/`,
    Component: <Temple />
  },
  {
    path: `${process.env.PUBLIC_URL}/Temple_Trust/templeTrust/:layout/`,
    Component: <TempleTrust />
  },
  {
    path: `${process.env.PUBLIC_URL}/DonationMaster/DonationMaster/:layout/`,
    Component: <DonationMaster />
  },
  {
    path: `${process.env.PUBLIC_URL}/DonarMaster/donar/:layout/`,
    Component: <Donar />
  },
  {
    path: `${process.env.PUBLIC_URL}/Statement/Statement/:personId/:statement/:layout/`,
    Component: <Statement />
  },
  {
    path: `${process.env.PUBLIC_URL}/Notes/notes/:layout/`,
    Component: <Notes />
  },
  {
    path: `${process.env.PUBLIC_URL}/Accommodation/accommodation/:layout/`,
    Component: <Accommodation />
  },
  {
    path: `${process.env.PUBLIC_URL}/MealPass/meal-pass/:layout/`,
    Component: <MealPass />
  },
  {
    path: `${process.env.PUBLIC_URL}/Events/events/:layout/`,
    Component: <Events />
  },
  {
    path: `${process.env.PUBLIC_URL}/Events/event/:eventId/:layout/`,
    Component: <EventDetail />
  },

  {
    path: `${process.env.PUBLIC_URL}/BillManagement/bill-management/:layout/`,
    Component: <BillManagement />
  },
  {
    path: `${process.env.PUBLIC_URL}/BillManagement/PaymentBill/:vendorId/:layout/`,
    Component: <PaymentBillManagement />
  },
  {
    path: `${process.env.PUBLIC_URL}/AccommodationDetail/accommodation/:bookingId/:layout/`,
    Component: <AccommodationDetail />
  },
  {
    path: `${process.env.PUBLIC_URL}/Income/income/:layout/`,
    Component: <Income />
  },
  {
    path: `${process.env.PUBLIC_URL}/Expance/expance/:layout/`,
    Component: <Expace />
  },
  {
    path: `${process.env.PUBLIC_URL}/SlipDownloadeTemplate/SlipDownloadeTemplate/:layout/`,
    Component: <SlipDownloadeTemplate />
  },
  {
    path: `${process.env.PUBLIC_URL}/Organization/Organizationa/:layout/`,
    Component: <Organization />
  },
  {
    path: `${process.env.PUBLIC_URL}/PrivillageManager/PrivillageManager/:layout/`,
    Component: <PrivillageManager />
  },
  {
    path: `${process.env.PUBLIC_URL}/ModualManager/ModualManager/:layout/`,
    Component: <ModualManager />
  }
];
